import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'

import { getItems, updateItem } from 'Redux/actions/item-actions'

import ItemsTable from 'Components/ItemsTable'
import { PageTitle } from 'Common/styled'

class Archive extends Component {
  static propTypes = {
    getItems: PropTypes.func,
    items: PropTypes.array,
    storeId: PropTypes.number
  }

  state = {
    isLoading: false
  }

  componentDidMount() {
    this.getItems()
  }
  componentDidUpdate(prevProps, prevState) {
    const { storeId } = this.props
    if (prevProps.storeId !== storeId) this.getItems()
  }

  getItems = async () => {
    const { getItems } = this.props
    this.setState({ isLoading: true })
    await getItems('archive')
    this.setState({ isLoading: false })
  }

  viewItem = async (itemNumber, type) => {
    const { history, updateItem } = this.props
    await updateItem({ objectType: type })
    return history.push(`/item/${itemNumber}`)
  }

  render() {
    const { isLoading } = this.state
    const { items } = this.props
    return (
      <>
        <PageTitle>
          <FormattedMessage id={'archive.title'} />
        </PageTitle>
        <ItemsTable isLoading={isLoading} data={items} viewItem={this.viewItem} />
      </>
    )
  }
}

const mapStateToProps = state => ({
  storeId: state.user.current.storeId,
  items: state.item.list
})
const mapDispatchToProps = {
  getItems,
  updateItem
}
export default connect(mapStateToProps, mapDispatchToProps)(Archive)
